import { render, staticRenderFns } from "./CopyStakeAiStreamersFilter.vue?vue&type=template&id=5e2fa05d&scoped=true&lang=pug"
import script from "./CopyStakeAiStreamersFilter.vue?vue&type=script&lang=ts"
export * from "./CopyStakeAiStreamersFilter.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeAiStreamersFilter.vue?vue&type=style&index=0&id=5e2fa05d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2fa05d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSelect,VTextField})
